module.exports = __webpack_public_path__ + "img/billmenu2.aee1a149.png";